import { Box, Button, FileInput, Input, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, Textarea, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import classes from '../Managepallets.module.css'
import { notifications } from '@mantine/notifications';


const Addrawmaterial = () => {
    const navigate = useNavigate();
    const [pallets, setPallets] = useState<string>('');
    const [cotwo, setCoTwo] = useState<string>('');
    const [sourceName, setSourceName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/pallets/update/${id}` : `${baseUrl}admin/pallets/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postPallets,
    } = useFetch({
        method: method,
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            pallet_name: pallets,
            co2_embodiment: cotwo,
            source_name: sourceName,
            description: description
        }),
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/pallets/${id}`)
        }
    }, [])
    useEffect(() => {
        if (getfieldData?.data?.rows[0]) {
            setPallets(getfieldData?.data?.rows[0]?.pallet_name || '');
            setCoTwo(getfieldData?.data?.rows[0]?.co2_embodiment || '');
            setSourceName(getfieldData?.data?.rows[0]?.source_name || '');
            setDescription(getfieldData?.data?.rows[0]?.description || '');
        }
    }, [getfieldData]);

    // **Reusable function to handle input change and remove errors**
    const handleChange = (field: string, value: string | null) => {
        if (field === "pallets_type") {
            setPallets(value as string);
        }
        else if (field === "co2_id") {
            setCoTwo(value as string);
        }
        else if (field === "source_name") {
            setSourceName(value as string);
        }
        else if (field === "description") {
            setDescription(value as string);
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    // **Validate inputs before submitting**
    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!pallets.trim()) {
            newErrors.pallets_type = "Pallet name is Required";
        }
        if (!cotwo) {
            newErrors.co2_id = "CO₂ is Required";
        }
        if (!sourceName) {
            newErrors.source_name = "Source Name is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return; // Stop if validation fails
        await postPallets(url);
    };
    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/pallets');
        }
    }, [getData, getError, navigate, classes]);


    // const handlesave = async () => {
    //     await postPallets(url);
    //     navigate('/manage-raw-material');
    // };
    return (
        <>
            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add Pallets</Title>
                    <Space h="lg" />
                    <Text>Pallets Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <TextInput
                            variant='filled'
                            label="Pallets Name"
                            withAsterisk
                            value={pallets}
                            onChange={(e) => handleChange("pallets_type", e.target.value)}
                            placeholder="Pallets Name"
                            radius={6}
                            error={errors.pallets_type}
                        />

                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Per/Kg CO₂ Embodiment"
                            value={cotwo}
                            onChange={(e) => handleChange("co2_id", e.target.value)}
                            placeholder="Enter Embodied"
                            radius={6}
                            error={errors.co2_id}
                        />
                        <TextInput
                            variant='filled'
                            withAsterisk
                            label="Source Name"
                            value={sourceName}
                            onChange={(e) => handleChange("source_name", e.target.value)}
                            placeholder="Enter Source Name"
                            radius={6}
                            error={errors.source_name}
                        />
                        <Textarea
                            label="Source Description"
                            placeholder="Enter your Source Description"
                            variant="filled"
                            autosize
                            value={description}
                            onChange={(e) => handleChange("description", e.target.value)}
                            minRows={1}
                            maxRows={4}
                            radius={6}
                        />
                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/pallets')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                            loading={detailLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button></SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(Addrawmaterial)